import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { brand } from '../../data/palette';
interface AdvanceProps {
  label?: string;
  onClick: () => void;
  accent?: string;
  delay?: number;
  align?: 'left' | 'center';
}

/** The single forward affordance used at the end of a stage. */
export function Advance({
  label = 'Continue',
  onClick,
  accent = brand.green,
  delay = 0,
  align = 'left'
}: AdvanceProps) {
  return <motion.button type="button" onClick={onClick} initial={{
    opacity: 0,
    y: 12
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay,
    ease: [0.16, 1, 0.3, 1]
  }} className={`group inline-flex items-center gap-4 ${align === 'center' ? 'mx-auto' : ''}`} data-id="element-394" data-mp="31vt5rgbuvew6">
      <span className="label-mono text-[10px] text-enamel transition-colors duration-300 group-hover:text-enamel" data-id="element-395" data-mp="2iys3425rxqve">
        {label}
      </span>
      <span className="relative flex h-9 w-9 items-center justify-center rounded-full border border-enamel/25 transition-colors duration-500 group-hover:border-transparent" data-id="element-396" data-mp="2mz3jv3v0n71l">
        <span className="absolute inset-0 scale-0 rounded-full opacity-0 transition-all duration-500 group-hover:scale-100 group-hover:opacity-100" style={{
        backgroundColor: accent
      }} data-id="element-397" data-mp="5k69kobi2ynl" />
        <ArrowRightIcon className="relative h-4 w-4 text-enamel transition-transform duration-500 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-398" data-mp="fivrgh3ecj3u" />
      </span>
    </motion.button>;
}